module.exports = __webpack_public_path__ + "img/nav-bar-bg.8eac3a0b.png";